<template>
  <h1 class="hkwh">杭开文化</h1>
  <div class="culture-box banCopy" v-html="inHtmlString">
    
  </div>
</template>

<script>
export default {
  mounted() {
    this.Post();
  },
  methods: {
    Post() {
      var url = "http://demoapi.hkjt.cn/pages/corporateCulture.php?type=2";

      this.axios
        .get(url)
        .then((res) => {
          this.inHtmlString = res.data[0]["content"];
        })
        .catch((e) => {
          if (e.response) {
            //请求已发出，服务器返回状态码不是2xx。
            console.info(e.response.data);
            console.info(e.response.status);
            console.info(e.response.headers);
          } else if (e.request) {
            // 请求已发出，但没有收到响应
            // e.request 在浏览器里是一个XMLHttpRequest实例，
            // 在node中是一个http.ClientRequest实例
            console.info(e.request);
          } else {
            //发送请求时异常，捕捉到错误
            console.info("error", e.message);
          }
          console.info(e.config);
        });
    },
  },
  data() {
    return {
      inHtmlString: "",
    };
  },
};
</script>

<style scoped>
.culture-title {
  color: #e8623e;
  font-family: '仿宋';
  font-weight: bold;
}
</style>